import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onFilterToggle }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="p-4">
        <form onSubmit={handleSearch} className="flex gap-2">
          <div className="flex-1 relative">
            <Icon
              name="Search"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search documents by name, content, or tags..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
          <Button
            type="button"
            variant="outline"
            size="default"
            iconName="SlidersHorizontal"
            onClick={() => setIsAdvancedOpen(!isAdvancedOpen)}
          >
            Filters
          </Button>
          <Button type="submit" variant="default" size="default" iconName="Search">
            Search
          </Button>
        </form>

        {isAdvancedOpen && (
          <div className="mt-4 p-4 bg-muted rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-xs font-medium text-foreground mb-2">
                  Date Range
                </label>
                <select className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                  <option value="">All Time</option>
                  <option value="today">Today</option>
                  <option value="week">This Week</option>
                  <option value="month">This Month</option>
                  <option value="quarter">This Quarter</option>
                  <option value="year">This Year</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground mb-2">
                  Document Type
                </label>
                <select className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                  <option value="">All Types</option>
                  <option value="pdf">PDF</option>
                  <option value="doc">Word Document</option>
                  <option value="xls">Excel Spreadsheet</option>
                  <option value="image">Image</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground mb-2">
                  Category
                </label>
                <select className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                  <option value="">All Categories</option>
                  <option value="invoice">Invoice</option>
                  <option value="bl">Bill of Lading</option>
                  <option value="certificate">Certificate</option>
                  <option value="contract">Contract</option>
                  <option value="inspection">Inspection Report</option>
                </select>
              </div>
            </div>
            <div className="flex items-center justify-end gap-2 mt-4">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setIsAdvancedOpen(false)}
              >
                Clear Filters
              </Button>
              <Button variant="default" size="sm" onClick={() => setIsAdvancedOpen(false)}>
                Apply Filters
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;